/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authstartwrongemail3Inputs */

const en_authstartwrongemail3 = /** @type {(inputs: Authstartwrongemail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrong email?`)
};

const pt_authstartwrongemail3 = /** @type {(inputs: Authstartwrongemail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email errado?`)
};

/**
* | output |
* | --- |
* | "Wrong email?" |
*
* @param {Authstartwrongemail3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authstartwrongemail3 = /** @type {((inputs?: Authstartwrongemail3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authstartwrongemail3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authstartwrongemail3(inputs)
	return pt_authstartwrongemail3(inputs)
});
export { authstartwrongemail3 as "authStartWrongEmail" }